import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { prices, pricingAnchor } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-97" data-mp="2hoic2ghszh3j">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 right-3 z-50 flex justify-center md:left-auto md:right-6" data-id="element-98" data-mp="2hnfooijovwsd">
          <a href={pricingAnchor} className="w-full rounded-2xl border-b-4 border-sky-800 bg-sky-600 px-6 py-3.5 text-center text-base font-black uppercase tracking-wide text-white shadow-xl shadow-sky-600/40 transition-colors duration-150 ease-out hover:bg-sky-700 focus:outline-none focus:ring-4 focus:ring-sky-600/30 md:w-auto" data-id="element-99" data-mp="35ecnctmh4xlo">
            🔨 Quiero mis 50 proyectos · {prices.today} →
          </a>
        </motion.div>}
    </AnimatePresence>;
}